(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
(function () {
  'use strict';



function updateVariantAvailability() {
  var variants = window.__productVariants;
  if (!variants) return;

  var selected = [];
  document.querySelectorAll('.flavor-selector__grid').forEach(function (g) {
    var pos = parseInt(g.getAttribute('data-option-position'), 10);
    var active = g.querySelector('.flavor-btn--selected');
    selected[pos - 1] = active ? active.getAttribute('data-value') : null;
  });

  function matches(v, sel) {
    var opts = [v.option1, v.option2, v.option3];
    for (var i = 0; i < sel.length; i++) {
      if (sel[i] && opts[i] !== sel[i]) return false;
    }
    return true;
  }

  // Har button ko check karo — agar us value ke sath koi bhi available variant nahi milta, sold-out mark karo
  document.querySelectorAll('.flavor-selector__grid').forEach(function (grid) {
    var pos = parseInt(grid.getAttribute('data-option-position'), 10);
    grid.querySelectorAll('.flavor-btn').forEach(function (btn) {
      var val = btn.getAttribute('data-value');
      var testSel = selected.slice();
      testSel[pos - 1] = val;
      var anyAvailable = variants.some(function (v) { return matches(v, testSel) && v.available; });
      btn.classList.toggle('flavor-btn--soldout', !anyAvailable);
    });
  });

  // Fully selected variant dhoondo aur add-to-cart update karo
  var matched = null;
  if (selected.length && selected.every(function (s) { return s; })) {
    matched = variants.find(function (v) { return matches(v, selected); });
  } else if (variants.length === 1) {
    matched = variants[0];
  }

    var addBtn = document.querySelector('.btn-add-to-cart');
    var soldoutTag = document.querySelector('[id^="soldout-tag-"]');

    if (!matched) return;

    if (matched.available) {
      if (addBtn) {
        addBtn.disabled = false;
        var addText = addBtn.querySelector('[data-add-to-cart-text]');
        if (addText) addText.textContent = 'Add to Cart';
      }
      if (soldoutTag) soldoutTag.style.display = 'none';
    } else {
      if (addBtn) {
        addBtn.disabled = true;
        var addText2 = addBtn.querySelector('[data-add-to-cart-text]');
        if (addText2) addText2.textContent = 'Out of Stock';
      }
      if (soldoutTag) soldoutTag.style.display = 'inline-block';
    }
  }




  // ---- GALLERY ----
  var mediaEls = document.querySelectorAll('[data-testid="product-information-media"]');
  mediaEls.forEach(function (mediaEl) {
    var mainImg = mediaEl.querySelector('[id^="gallery-main-img-"]');
    if (!mainImg) return;

    var sid = mainImg.id.replace('gallery-main-img-', '');
    var thumbs = mediaEl.querySelectorAll('.gallery-thumb');
    var imgs = [];
    thumbs.forEach(function (t) { imgs.push(t.getAttribute('data-src')); });
    if (imgs.length === 0) return;

    var currentIndex = 0;

    function goTo(idx) {
      if (idx < 0) idx = imgs.length - 1;
      if (idx >= imgs.length) idx = 0;
      currentIndex = idx;

      mainImg.style.opacity = '0';
      setTimeout(function () {
        mainImg.src = imgs[currentIndex];
        mainImg.style.opacity = '1';
      }, 150);

      var counter = document.getElementById('gallery-current-' + sid);
      if (counter) counter.textContent = currentIndex + 1;

      thumbs.forEach(function (t, i) {
        t.classList.toggle('gallery-thumb--active', i === currentIndex);
      });
      thumbs[currentIndex] && thumbs[currentIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { goTo(parseInt(t.getAttribute('data-index'))); });
    });

    var prevBtn = document.getElementById('gallery-prev-' + sid);
    var nextBtn = document.getElementById('gallery-next-' + sid);
    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(currentIndex - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(currentIndex + 1); });

    // Swipe
    var touchStartX = 0;
    var mainWrap = document.getElementById('gallery-main-' + sid);
    if (mainWrap) {
      mainWrap.addEventListener('touchstart', function (e) { touchStartX = e.touches[0].clientX; }, { passive: true });
      mainWrap.addEventListener('touchend', function (e) {
        var diff = touchStartX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 40) goTo(diff > 0 ? currentIndex + 1 : currentIndex - 1);
      }, { passive: true });
    }

    // Lightbox
    var lightbox = document.getElementById('gallery-lightbox-' + sid);
    var lightboxImg = document.getElementById('gallery-lightbox-img-' + sid);
    var zoomBtn = document.getElementById('gallery-zoom-btn-' + sid);
    var closeBtn = document.getElementById('gallery-lightbox-close-' + sid);
    var lbPrev = document.getElementById('lightbox-prev-' + sid);
    var lbNext = document.getElementById('lightbox-next-' + sid);

    function openLightbox() {
      if (!lightbox || !lightboxImg) return;
      lightboxImg.src = imgs[currentIndex];
      lightbox.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function closeLightbox() {
      if (!lightbox) return;
      lightbox.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    if (zoomBtn) zoomBtn.addEventListener('click', openLightbox);
    if (mainImg) mainImg.addEventListener('dblclick', openLightbox);
    if (closeBtn) closeBtn.addEventListener('click', closeLightbox);
    if (lightbox) lightbox.addEventListener('click', function (e) { if (e.target === lightbox) closeLightbox(); });
    if (lbPrev) lbPrev.addEventListener('click', function () { goTo(currentIndex - 1); if (lightboxImg) lightboxImg.src = imgs[currentIndex]; });
    if (lbNext) lbNext.addEventListener('click', function () { goTo(currentIndex + 1); if (lightboxImg) lightboxImg.src = imgs[currentIndex]; });
  });

  // Esc key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.gallery-lightbox.is-open').forEach(function (lb) {
        lb.classList.remove('is-open');
        document.body.style.overflow = '';
      });
    }
  });

  // ---- ACCORDIONS ----
  document.querySelectorAll('[data-accordion]').forEach(function (acc) {
    var trigger = acc.querySelector('[data-accordion-trigger]');
    var body = acc.querySelector('[data-accordion-body]');
    if (!trigger || !body) return;

    // Init open ones
    if (trigger.getAttribute('aria-expanded') === 'true') {
      body.style.maxHeight = body.scrollHeight + 'px';
    }

    trigger.addEventListener('click', function () {
      var isOpen = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      if (isOpen) {
        body.style.maxHeight = '0';
        body.classList.remove('accordion__body--open');
      } else {
        body.classList.add('accordion__body--open');
        body.style.maxHeight = body.scrollHeight + 'px';
      }
    });
  });

  // ---- FLAVOR BUTTONS ----
  document.querySelectorAll('.flavor-selector__grid').forEach(function (grid) {
    grid.querySelectorAll('.flavor-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        grid.querySelectorAll('.flavor-btn').forEach(function (b) { b.classList.remove('flavor-btn--selected'); });
        btn.classList.add('flavor-btn--selected');
        updateVariantAvailability();
        // Sab grids se selected values collect karo
        var selectedOptions = [];
        document.querySelectorAll('.flavor-selector__grid').forEach(function (g) {
          var active = g.querySelector('.flavor-btn--selected');
          if (active) selectedOptions.push(active.getAttribute('data-value'));
        });

        var variants = window.__productVariants;
        var mediaList = window.__productMedia;
        if (!variants || !mediaList) return;

        // Matching variant dhundo
        var matchedVariant = null;
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          var options = [v.option1, v.option2, v.option3].filter(Boolean);
          var matched = selectedOptions.every(function (sel) { return options.indexOf(sel) !== -1; });
          if (matched) { matchedVariant = v; break; }
        }

        if (!matchedVariant) return;

        // Variant ID update karo
        var mainImgEl = document.querySelector('[id^="gallery-main-img-"]');
        if (!mainImgEl) return;
        var sid = mainImgEl.id.replace('gallery-main-img-', '');
        var variantInput = document.getElementById('variant-id-' + sid);
        if (variantInput) variantInput.value = matchedVariant.id;

        // Featured image nahi hai tu kuch nahi karna
        if (!matchedVariant.featured_image) return;

        var fi = matchedVariant.featured_image;

        // Saare possible ID fields try karo
        var variantMediaId = fi.media_id || fi.id || null;

        var targetIndex = -1;

        // Method 1: ID se match karo
        if (variantMediaId) {
          for (var j = 0; j < mediaList.length; j++) {
            if (String(mediaList[j].id) === String(variantMediaId)) {
              targetIndex = j;
              break;
            }
          }
        }

        // Method 2: src/filename se match karo (fallback)
        if (targetIndex === -1 && fi.src) {
          // Shopify image URL se filename nikalo
          var fiSrc = fi.src.split('?')[0].split('/').pop();
          var thumbEls2 = document.querySelectorAll('[data-testid="product-information-media"] .gallery-thumb');
          thumbEls2.forEach(function (t, i) {
            if (targetIndex !== -1) return;
            var tSrc = (t.getAttribute('data-src') || '').split('?')[0].split('/').pop();
            // Shopify adds size suffix like _900x900 — remove it for comparison
            var tBase = tSrc.replace(/_\d+x\d*/, '');
            var fiBase = fiSrc.replace(/_\d+x\d*/, '');
            if (tBase && fiBase && tBase === fiBase) {
              targetIndex = i;
            }
          });
        }

        if (targetIndex === -1) return;

        // Gallery ko us index par le jao
        var mediaEl = document.querySelector('[data-testid="product-information-media"]');
        if (!mediaEl) return;
        var thumbEls = mediaEl.querySelectorAll('.gallery-thumb');
        if (thumbEls[targetIndex]) thumbEls[targetIndex].click();
      });
    });
  });
  updateVariantAvailability();
})();

  } catch(e) { console.error(e); }
})();
})();
